import React, { Fragment } from 'react'
import { graphql } from "gatsby";

import Layout from '../layouts/layout';
import DynamicContentContainer from '../utils/dynamicContentContainer';
import { getComponentsFromPrismic } from '../utils/getComponentsFromPrismic';
import '../styles/innovation.scss';

class Econnect extends React.Component {
  render() {
    return (
      <Layout customClassName = "e-connect">
        <DynamicContentContainer name = { this.constructor.displayName } data = { getComponentsFromPrismic(this.props.data.allPrismicEConnect) } />
      </Layout>
    );
  }
}

export const query = graphql`
query GetEConnectContent {
	allPrismicEConnect {
    edges {
      node {
        data {
          body {
            items {
              component {
                type
                document {
                  ...PageHeroHeadingSubNavigation
                  ...BasicContentContainer
                  ...List
                  ...ImageOverlayTitle
                  ...Gallery
                  ...VideoEmbed
                }
              }
            }
          }
        }
      }
    }
  }
}`;

export default Econnect
